import React from 'react';
import DataTableEllipsisText from './DataTableEllipsisText';

const badgeStyle = {
    display: 'inline-block',
    flexShrink: 0,
    padding: '2px 6px',
    borderRadius: '8px',
    background: '#f8d7da',
    color: '#842029',
    border: '1px solid #f1aeb5',
    fontSize: '11px',
    fontWeight: 600,
    lineHeight: 1.2,
};

export function ObsoleteStatusBadge() {
    return <span style={badgeStyle}>Obsolete</span>;
}

export default function ObsoletePartNoCell({ value, isObsolete }) {
    if (!isObsolete) {
        return <DataTableEllipsisText value={value} />;
    }

    return (
        <button
            type="button"
            title="This Part No is obsolete. Please change the Part No."
            onClick={(event) => {
                event.stopPropagation();
                window.alert('This Part No is obsolete. Please change the Part No.');
            }}
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                maxWidth: '100%',
                minWidth: 0,
                padding: 0,
                border: 0,
                background: 'transparent',
                color: 'inherit',
                cursor: 'pointer',
                textAlign: 'left',
            }}
        >
            <span style={{ minWidth: 0 }}>
                <DataTableEllipsisText value={value} />
            </span>
            <ObsoleteStatusBadge />
        </button>
    );
}
